import { marked } from 'marked';

marked.setOptions({
  gfm: true,
  breaks: true
});

// Renderiza contenido Markdown a HTML seguro
export function renderMarkdown(md: string | null | undefined): string {
  if (!md) return '';
  try {
    return marked.parse(md, { async: false }) as string;
  } catch {
    return `<pre class="mb-0">${escapeHtml(md)}</pre>`;
  }
}

// Escapa caracteres especiales de HTML
function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
